import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRadio, useRadioGroup } from '@react-aria/radio';
import { useRadioGroupState } from '@react-stately/radio';
import omit from 'lodash/omit';
import React from 'react';
import { useTheme } from 'styled-components';
import { useAccessibleOnChange } from '../../utils/useAccessibleOnChange';
import { CardsContainer, Container, DisplayDiv, Indicator, StyledLabel, Wrapper } from './styles';
const RadioContext = React.createContext({
    name: '',
    isDisabled: false,
    isReadOnly: false,
    selectedValue: null,
    setSelectedValue: () => { },
    lastFocusedValue: null,
    setLastFocusedValue: () => { },
    validationState: 'invalid',
});
function RadioButton(props) {
    const { children, asCard, fullWidth, display, noMarginBottom } = props, htmlProps = __rest(props, ["children", "asCard", "fullWidth", "display", "noMarginBottom"]);
    const state = React.useContext(RadioContext);
    const ref = React.useRef(null);
    const massagedProps = Object.assign(Object.assign({ isDisabled: htmlProps.disabled, children }, htmlProps), { onFocus: htmlProps.onFocus, onBlur: htmlProps.onBlur });
    const { inputProps } = useRadio(massagedProps, state, ref);
    return (_jsxs(Container, { "$asCard": asCard, "$fullWidth": fullWidth, "$display": display, disabled: inputProps.disabled, checked: inputProps.checked, "$noMarginBottom": noMarginBottom, children: [_jsx("input", Object.assign({ type: "radio" }, htmlProps, inputProps)), _jsx(Indicator, {}), children] }));
}
const RadioGroup = (props) => {
    var _a;
    const { options, value, label, LabelComponent, onChange, onFocus, onBlur, disabled, required, readOnly, name: htmlName, asCards = false, fullWidth = false, noMarginBottom = false, display = 'block', } = props;
    const wrappedOnChange = useAccessibleOnChange(onChange, htmlName, 'radio');
    const massagedProps = Object.assign(Object.assign({}, props), { onChange: wrappedOnChange });
    const state = useRadioGroupState(massagedProps);
    const { radioGroupProps, labelProps } = useRadioGroup(massagedProps, state);
    const theme = useTheme();
    const buttons = (_jsxs(Wrapper, Object.assign({}, radioGroupProps, { "$fullWidth": fullWidth, children: [
            // eslint-disable-next-line no-nested-ternary
            LabelComponent ? (_jsx(LabelComponent, Object.assign({}, labelProps, { children: label }))) : label ? (
            // We need to omit color because labelProps is React.HTMLAttributes<HTMLElement> which could include color
            // but in practice a) it'll never be there, and b) it'd be the wrong type (a hexcode, not a palette key)
            _jsx(StyledLabel, Object.assign({}, omit(labelProps, 'color'), (_a = theme.radioGroup) === null || _a === void 0 ? void 0 : _a.labelProps, { children: label }))) : null, _jsx(RadioContext.Provider, { value: state, children: _jsx(DisplayDiv, { "$display": display, "$noMarginBottom": noMarginBottom, children: options.map(option => (_jsx(RadioButton, { onFocus: onFocus, onBlur: onBlur, value: option.value, id: option.id, checked: option.value === value, name: htmlName, disabled: disabled, required: required, readOnly: readOnly, asCard: asCards, fullWidth: fullWidth, display: display, noMarginBottom: noMarginBottom, children: option.label }, option.value))) }) })] })));
    return asCards ? _jsx(CardsContainer, { children: buttons }) : buttons;
};
export default RadioGroup;
//# sourceMappingURL=index.js.map